const teamPromotionComponent: {
  [key: string]: any;
} = {};

teamPromotionComponent["windsurge"] = require("./windsurge").default;

export default teamPromotionComponent;
